import { FieldContainer } from '@oy/ui';
import React, { FC } from 'react';
import {
  ActionMeta,
  GroupBase,
  MenuPlacement,
  StylesConfig,
} from 'react-select';
import CreatableSelect, { CreatableProps } from 'react-select/creatable';

type SelectOption = {
  label: string;
  value: string;
};

type DerivedCreatableSelectProps = Omit<
  CreatableProps<SelectOption, false, GroupBase<SelectOption>>,
  'onChange'
>;

type CreatableSelectProps = {
  isHorizontal?: boolean;
  label?: string;
  helpText?: string;
  errorMessage?: string;
  placement?: MenuPlacement | undefined;
  onChange?: (opt: SelectOption, actionMeta: ActionMeta<SelectOption>) => void;
} & DerivedCreatableSelectProps;

const Select: FC<CreatableSelectProps> = ({
  options,
  isDisabled = false,
  isHorizontal = false,
  defaultValue,
  value,
  label,
  placeholder,
  helpText,
  errorMessage,
  placement,
  onChange,
  onCreateOption,
}: CreatableSelectProps) => {
  const customStyles: StylesConfig<
    SelectOption,
    false,
    GroupBase<SelectOption>
  > = {
    control: base => ({
      ...base,
      borderColor: errorMessage ? '#d9534f' : '#ddd',
      '&:hover': {
        borderColor: errorMessage ? '#d9534f' : '#ddd',
      },
    }),
  };

  return (
    <FieldContainer
      label={label}
      helpText={helpText}
      isHorizontal={isHorizontal}
      errorMessage={errorMessage}
    >
      <CreatableSelect
        menuPlacement={placement}
        className="font-body-MdRegular"
        styles={customStyles}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        onCreateOption={onCreateOption}
        options={options}
        isDisabled={isDisabled}
      />
    </FieldContainer>
  );
};

export default Select;
